/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

import { motion } from "framer-motion";
// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDButton from "../../../../components/MDButton";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuItem } from "@mui/material";
import colors from "../../../../assets/theme/base/colors";
import constants from "../../../../common/constants";

function IdLinkCell_Ira({ id, object }) {
  var path = "./ira/app/incidents/report?reportid=" + id;

  const handleSubmit = () => {
    window.location.href = `${constants.domain}${path}`;
  };

  return (
    <MDBox display="flex" alignItems="center">
      <motion.div
        whileHover={{
          scale: 1.03,
          transition: { duration: 0 },
        }}
        onClick={handleSubmit}
      >
        <MDBox ml={1}>
          <MDTypography variant="caption" fontWeight="bold" color="primary">
            {`#IRA_${id}`}
          </MDTypography>
        </MDBox>
      </motion.div>
    </MDBox>
  );
}

// Setting default value for the props of IdCell
IdLinkCell_Ira.defaultProps = {
  checked: false,
};

// Typechecking props for the IdCell
IdLinkCell_Ira.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
};

export default IdLinkCell_Ira;
